document.addEventListener('alpine:init', () => {
    Alpine.data('packagesTableTooltip', (config) => ({
        tooltipOpen: false,
    }));
});
